<template>
  <v-form id="close_intervention_form" v-model="valid" ref="form" lazy-validation>
    <v-container fluid>
      <div class="pt-4">
        {{$t('intervention_close_select_date')}}
        <date-picker attach id="closeIntervention-closeDate" :date="closeDate" :minStart= "minStart" :maxEnd="now" @updated="updatedCloseDate"></date-picker>
      </div>
      <div class="pt-4">
        {{$t('intervention_close_reason')}}
        <v-select
            id="closeIntervention-reason"
            v-bind:items="closureReasonsSelect"
            v-model="closeReason"
            :label="$t('intervention_close_reason_prompt')"
            single-line
            required
            :rules="requiredRule"
            attach
          ></v-select>
      </div>
      <div class="pt-4">
        {{$t('intervention_close_summary')}}
        <v-text-field
            id="closeIntervention-summary"
            :label="$t('intervention_close_comments_prompt')"
            v-model="comments"
            multi-line
          ></v-text-field>
      </div>
      *{{$t('required_fields')}}
      <v-layout row justify-center class="mt-4">
        <v-btn
          id="closeIntervention-cancel"
          @click="cancel"
        >

          {{$t('cancel')}}
        </v-btn>
        <v-btn
          id="closeIntervention-close"
          @click="closeIntervention"
          color="primary"
        >
          {{$t('confirm')}}
        </v-btn>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import DatePicker from '../date/DatePicker'
import moment from 'moment-es6'
import { mapState } from 'vuex'
import {
  SET_CLOSE_INTERVENTION_FORM_VALID
} from '../../store/mutation-types'
import {
  CLOSE_INTERVENTION
} from '../../store/action-types'

export default {
  name: 'close-intervention-form',
  props: ['cancel'],
  data () {
    return {
      now: moment().format('YYYY-MM-DD'),
      closeDate: moment().format('YYYY-MM-DD'),
      closeReason: '',
      comments: '',
      requiredRule: [v => !!v || this.$t('field_required')]
    }
  },
  methods: {
    resetForm () {
      this.closeDate = moment().format('YYYY-MM-DD')
      this.closeReason = ''
      this.comments = ''
      this.$refs.form.inputs.forEach((input) => {
        input.shouldValidate = false
        input.isBooted = false
        input.hasFocused = false
      })
    },
    updatedCloseDate (newDate) {
      this.closeDate = newDate
    },
    closeIntervention () {
      if (this.$refs.form.validate()) {
        const payload = {
          id: this.intervention.id,
          closureReasonId: this.closeReason,
          closureDate: this.closeDate,
          closureReasonSummary: this.comments
        }
        this.$store.dispatch(CLOSE_INTERVENTION, payload)
      }
    }
  },
  computed: {
    ...mapState({
      closureReasons: state => state.intervention.closureReasons,
      intervention: state => state.closeIntervention.intervention
    }),
    closureReasonsSelect () {
      return this.closureReasons.map(item => {
        return {
          text: this.$t(item.text),
          value: item.value
        }
      })
    },
    minStart () {
      return moment(this.intervention.creationDate).format('YYYY-MM-DD')
    },
    valid: {
      get () {
        return this.$store.state.closeIntervention.valid
      },
      set (value) {
        this.$store.commit(SET_CLOSE_INTERVENTION_FORM_VALID, value)
      }
    }
  },
  components: {
    DatePicker
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/intervention/CloseInterventionForm.vue